import { BaseInput } from "shared/components/forms/BaseInput";
import { type CredentialFormProps } from "./types";
import { SyncOptionRadioGroup } from "./fields/SyncOptionRadioGroup";

export const RentManagerCredentialForm = ({
  register
}: CredentialFormProps) => {
  const syncField = register("rent_manager_sync");

  return (
    <>
      <BaseInput
        id="rent_manager_company_code"
        label="Rent Manager company code"
        {...register("rent_manager_company_code")}
        required
      />

      <SyncOptionRadioGroup
        field={syncField}
        prose={
          <>
            Sync Rent Manager{" "}
            <span className="font-bold">&quot;Online Listings&quot;</span>{" "}
            status with the ability to submit applications
          </>
        }
      />
    </>
  );
};
